import React, { useEffect, useState } from 'react';
import WhatsAppIcon from './WhatsAppIcon';

export default function FloatingWhatsApp() {
  const [bottomOffset, setBottomOffset] = useState(5);

  useEffect(() => {
    const updatePosition = () => {
      const legalBar = document.querySelector('.footer-legal-bar');
      if (!legalBar) return setBottomOffset(5);

      const legalBarTop = legalBar.getBoundingClientRect().top;
      setBottomOffset(Math.max(5, window.innerHeight - legalBarTop + 5));
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, { passive: true });
    window.addEventListener('resize', updatePosition);
    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, []);

  return (
    <a
      className="global-whatsapp-button"
      style={{ bottom: `${bottomOffset}px` }}
      href="https://wa.me/33698681150"
      target="_blank"
      rel="noreferrer"
      aria-label="Contacter MCE sur WhatsApp"
      title="Écrire à MCE sur WhatsApp"
    >
      <WhatsAppIcon className="whatsapp-icon-svg" />
    </a>
  );
}
